// Is the billing surface offered to this user?
//
// ONE predicate, shared by the settings-section registry and by the user-menu
// item that opens it. Those two disagreeing is not hypothetical — the menu
// entry was originally omitted while the section existed, so the section was
// only reachable by typing `?settings=usage-credits` by hand.
//
// Both gates are required and they are independent:
//   * billing_audience — meta_only by default, or all signed-in users;
//   * `billing_sandbox_enabled` — default OFF, so the feature is absent
//     everywhere until it is deliberately turned on.

import { useAuth } from '../../contexts/AuthContext'
import { useBooleanFlagValue, useStringFlagValue } from '../../hooks/useBooleanFlagValue'
import { canSeeBilling } from './billingAccess'
import { useActiveTeam } from '../../contexts/ActiveTeamContext'
import { canViewTeamCredits } from './creditVisibility'
import { useTeamsEnabled } from '../teams/useTeamsEnabled'

export function useBillingVisible(): boolean {
  const { user } = useAuth()
  const { activeTeam } = useActiveTeam()
  const teamsEnabled = useTeamsEnabled()
  const billingSandboxEnabled = useBooleanFlagValue('billing_sandbox_enabled', false)
  const audience = useStringFlagValue('billing_audience', 'meta_only')
  return canSeeBilling(user, undefined, audience) && billingSandboxEnabled && (
    !teamsEnabled || canViewTeamCredits(activeTeam)
  )
}
